import { render, staticRenderFns } from "./ImportModelForm.vue?vue&type=template&id=388c5f5c&scoped=true&"
import script from "./ImportModelForm.vue?vue&type=script&lang=js&"
export * from "./ImportModelForm.vue?vue&type=script&lang=js&"
import style0 from "./ImportModelForm.vue?vue&type=style&index=0&id=388c5f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c5f5c",
  null
  
)

export default component.exports